
import { Button } from "@/components/ui/button";
import { ArrowLeft, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const CourseNotFound = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-[60vh] flex items-center justify-center flex-col gap-6 p-8">
      <div className="w-20 h-20 bg-muted/30 rounded-full flex items-center justify-center">
        <Search className="h-10 w-10 text-muted-foreground/60" />
      </div>
      
      <div className="text-center max-w-md">
        <h2 className="text-3xl font-bold mb-2">Course Not Found</h2>
        <p className="text-muted-foreground mb-6">
          The course you're looking for doesn't exist or you don't have access to it.
          Please check the URL or browse available courses.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button onClick={() => navigate('/')}>
            <ArrowLeft className="h-4 w-4 mr-2" /> Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};
